import { DANGER, GREEN } from '../Theme/palette';
import React from 'react';

import { ServiceGroupSelect } from '@components';
import { L } from '@lib';
import { Button, Col, Row, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ServiceGroup } from '@services';

const { Text } = Typography;

interface IProps {
  serviceGroup?: ServiceGroup;
  categoryTitle?: string;
  required?: boolean;
  setShowServiceGroupForm: (value: boolean) => void;
  handleServiceGroupClear: () => void;
  handleServiceGroupSelect: (id: number) => void;
  handleServiceGroupDeselect: (id: number) => void;
}

export const ServiceGroupAddSelect: React.FC<IProps> = ({
  serviceGroup,
  required = false,
  categoryTitle = 'Service category',
  setShowServiceGroupForm,
  handleServiceGroupClear,
  handleServiceGroupSelect,
  handleServiceGroupDeselect,
}) => {
  return (
    <div style={{ marginBottom: 16 }}>
      {categoryTitle && (
        <Text>
          <Text strong style={{ color: DANGER.tag }}>
            *
          </Text>{' '}
          {L(categoryTitle)}
        </Text>
      )}

      <Row align="middle" gutter={8} wrap={false}>
        <Col flex="auto">
          <ServiceGroupSelect
            value={serviceGroup?.id}
            defaultValue={serviceGroup && { value: serviceGroup?.id, label: serviceGroup?.name }}
            status={required ? 'error' : undefined}
            onSelect={handleServiceGroupSelect}
            onDeselect={handleServiceGroupDeselect}
            onClear={handleServiceGroupClear}
          />
        </Col>
        <Col flex="none">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setShowServiceGroupForm(true)}
            style={{ background: GREEN.badge, borderColor: GREEN.badge, minWidth: 110 }}
          >
            {L('Add new')}
          </Button>
        </Col>
      </Row>
      {required && <Text style={{ color: 'red' }}>{L('Required')}</Text>}
    </div>
  );
};
